"use client";

import React from "react";

import { FeatureFlags } from "@/enums/feature-flags";
import { AdminRole, UserRole } from "@/enums/roles.enum";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useSession } from "@/providers/SessionProvider";

export const RealtorOnly: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, user } = useSession();

  // Single role system
  const userRole = user?.role;

  // Check role-based access
  const allowedRoles = [
    UserRole.USER_REALTOR,
    AdminRole.ADMIN,
    AdminRole.SUPER_ADMIN,
    AdminRole.MAIN_REALTOR,
    AdminRole.REALTOR,
    AdminRole.SECRETARY,
  ];

  const allowed =
    isAuthenticated && userRole && allowedRoles.includes(userRole as any);
  if (!allowed) return null;
  return <>{children}</>;
};

export default RealtorOnly;
